import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'

Vue.use(Router)
// tss-pay tss-pay 支付  tss-pay tss支付
const router = new Router({
  mode: "history",
  base: '/taro-pay/',
  routes: [
    {
      path: '/',
      component: () => import('@/views/home/index'),
      meta: {
        title: '正在加载...'
      },
    },
    {
      path: '/payment',
      component: () => import('@/views/payment/index.vue'),
      meta: {
        title: '请工程师代付'
      }
    },
    {
      path: '/payment-bosch',
      component: () => import('@/views/payment-bosch/index.vue'),
      meta: {
        title: '请工程师代付'
      }
    },
    {
      path: '/web',
      component: () => import('@/views/web/index.vue'),
      meta: {
        title: '手机端'
      }
    }
  ],
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '请工程师代付'
  next()
})

export default router
